import axios from 'axios'

// const baseURL = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:9080/api'
const baseURL = process.env.NODE_ENV === "production" ? "/api" : "http://192.168.0.102:9080/api";

const instance = axios.create({
  baseURL: baseURL,
  timeout: 10000
})

instance.interceptors.request.use(config => {
  const token = sessionStorage.getItem('admin_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

instance.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response && error.response.status === 401) {
    // 检查当前是否已经在登录页面，避免重复重定向
    const currentPath = window.location.pathname
    if (currentPath !== '/admin/login') {
      sessionStorage.removeItem('admin_logged')
      sessionStorage.removeItem('admin_token')
      sessionStorage.removeItem('admin_user')
      window.location.href = '/admin/login'
    }
  }
  return Promise.reject(error)
})

export const getDingTalkAuthUrl = () => {
  return instance.get('/auth/dingtalk/url')
}

export const dingtalkCallback = (code) => {
  return instance.get('/auth/dingtalk/callback', { params: { code } })
}

export const getArticles = (page, size, keyword) => {
  return instance.get('/articles', { params: { page, size, keyword } })
}

export const getPublishedArticles = (page, size, sort) => {
  return instance.get('/articles/published', { params: { page, size, sort } })
}

export const getArticle = (id) => {
  return instance.get(`/articles/${id}`)
}

export const searchArticles = (params) => {
  return instance.get('/articles/search', { params })
}

export const getRecentArticles = () => {
  return instance.get('/articles/recent')
}

export const getArchiveData = () => {
  return instance.get('/articles/archive')
}

export const incrementView = (id, fingerprint) => {
  return instance.post(`/articles/${id}/view`, null, { params: { fingerprint } })
}

export const toggleLike = (id, fingerprint) => {
  return instance.post(`/articles/${id}/like`, null, { params: { fingerprint } })
}

export const checkLiked = (id, fingerprint) => {
  return instance.get(`/articles/${id}/liked`, { params: { fingerprint } })
}

export const saveArticle = (data) => {
  return instance.post('/articles', data)
}

export const deleteArticle = (id) => {
  return instance.delete(`/articles/${id}`)
}

export const publishArticleApi = (id) => {
  return instance.post(`/articles/${id}/publish`)
}

export const unpublishArticleApi = (id) => {
  return instance.post(`/articles/${id}/unpublish`)
}

export const getCategories = () => {
  return instance.get('/categories')
}

export const getCategory = (id) => {
  return instance.get(`/categories/${id}`)
}

export const saveCategory = (data) => {
  return instance.post('/categories', data)
}

export const deleteCategory = (id) => {
  return instance.delete(`/categories/${id}`)
}

export const getTags = () => {
  return instance.get('/tags')
}

export const getTag = (id) => {
  return instance.get(`/tags/${id}`)
}

export const saveTag = (data) => {
  return instance.post('/tags', data)
}

export const deleteTag = (id) => {
  return instance.delete(`/tags/${id}`)
}

export const getComments = (page, size, status, keyword, articleId) => {
  return instance.get('/comments', { params: { page, size, status, keyword, articleId } })
}

export const getArticleComments = (articleId, page, size) => {
  return instance.get(`/comments/article/${articleId}`, { params: { page, size } })
}

export const createComment = (data) => {
  return instance.post('/comments', data)
}

export const approveComment = (id) => {
  return instance.post(`/comments/${id}/approve`)
}

export const blockComment = (id) => {
  return instance.post(`/comments/${id}/block`)
}

export const deleteComment = (id) => {
  return instance.delete(`/comments/${id}`)
}

export const getUsers = (page, size) => {
  return instance.get('/users', { params: { page, size } })
}

export const registerUser = (data) => {
  return instance.post('/users/register', data)
}

export const loginUser = (data) => {
  return instance.post('/users/login', data)
}

export const deleteUser = (id) => {
  return instance.delete(`/users/${id}`)
}

export const getConfigs = () => {
  return instance.get('/configs')
}

export const updateConfigs = (configs) => {
  return instance.put('/configs', configs)
}

// 订阅邮件
export const subscribeEmail = (email) => {
  return instance.post('/subscribe', { email })
}
